/**
 * Плашка состояния.
 *
 * Статус в таблице — **про жизненный цикл сущности**: черновик,
 * опубликовано, в продаже. Деньги в плашку не кладутся, у них
 * своя колонка (кит, п. 5).
 */
export type PillTone = 'ok' | 'warn' | 'crit' | 'info' | 'mut';

export function Pill({ tone, children }: { tone: PillTone; children: string }) {
  return <span className={`pill p-${tone}`}>{children}</span>;
}
